import { TTab, TTabs } from '../../utils';
import { Tab } from './Tab/Tab';
import style from './Tabs.module.scss';

type Props = {
  tabsList: TTabs;
  activeTab: TTab | null;
  setActiveTab: (tab: TTab) => void;
};

export const Tabs = ({ tabsList, activeTab, setActiveTab }: Props) => {
  return (
    <div className={style.container}>
      {tabsList.map((name) => {
        return (
          <Tab
            key={name}
            setActiveTab={setActiveTab}
            name={name}
            active={name === activeTab}
          />
        );
      })}
    </div>
  );
};
